import type { ReactNode } from 'react';

import GoButton from '@cartwhl/ui/input/GoButton';

import useAppletsUrl from '../../../hooks/useAppletsUrl';

interface MotionEditorCTAProps {
  children?: ReactNode;
}

export default function MotionEditorCTA({
  children = 'Try Performance Editor',
}: MotionEditorCTAProps) {
  const appletsUrl = useAppletsUrl();

  return (
    <p className="mb-8">
      <a
        href={appletsUrl && `${appletsUrl}/motion-editor`}
        target="_blank"
        rel="noopener noreferrer"
        className="no-underline hover:no-underline"
      >
        <GoButton variant="animate" className="px-10">
          {children}
        </GoButton>
      </a>
    </p>
  );
}
